<div class="booking-page">
      <header class="header">
        <div class="header-container">
          <a routerLink="/" class="logo">
            <img src="assets/images/logo%20kia%20ora.png" alt="Serenity Hotel" class="logo-img">
          </a>

          <nav class="nav-links">
            <a routerLink="/">{{ 'NAV.HOME' | translate }}</a>
            <a routerLink="/about">{{ 'NAV.ABOUT' | translate }}</a>
            <a routerLink="/contact">{{ 'NAV.CONTACT' | translate }}</a>
            <a routerLink="/gallery">{{ 'NAV.GALLERY' | translate }}</a>
            <a *ngIf="authService.currentUser$ | async" routerLink="/profile">{{ 'NAV.PROFILE' | translate }}</a>
          </nav>

          <div class="header-actions">
            <ng-container *ngIf="authService.currentUser$ | async as user; else guestLinks">
              <a routerLink="/profile" class="sign-in-link">{{ user.firstName || user.username }}</a>
              <button class="logout-btn" (click)="authService.logout()">{{ 'NAV.LOGOUT' | translate }}</button>
            </ng-container>
            <ng-template #guestLinks>
              <a routerLink="/auth/login" class="sign-in-link">{{ 'NAV.SIGN_IN' | translate }}</a>
            </ng-template>
            <a routerLink="/booking" class="book-now-btn active">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
                <line x1="16" y1="2" x2="16" y2="6"></line>
                <line x1="8" y1="2" x2="8" y2="6"></line>
                <line x1="3" y1="10" x2="21" y2="10"></line>
              </svg>
              {{ 'NAV.BOOK_NOW' | translate }}
            </a>
          </div>
        </div>
      </header>

      <div class="search-section">
        <div class="search-container">
          <div class="search-bar">
            <div class="search-field">
              <label>{{ 'BOOKING.CHECK_IN' | translate }} <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect><line x1="16" y1="2" x2="16" y2="6"></line><line x1="8" y1="2" x2="8" y2="6"></line><line x1="3" y1="10" x2="21" y2="10"></line></svg></label>
              <input type="date" [(ngModel)]="checkIn" (change)="loadAvailabilities()" />
            </div>
            <div class="search-divider"></div>
            <div class="search-field">
              <label>{{ 'BOOKING.CHECK_OUT' | translate }} <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect><line x1="16" y1="2" x2="16" y2="6"></line><line x1="8" y1="2" x2="8" y2="6"></line><line x1="3" y1="10" x2="21" y2="10"></line></svg></label>
              <input type="date" [(ngModel)]="checkOut" (change)="loadAvailabilities()" />
            </div>
            <div class="search-divider"></div>
            <div class="search-field counter-field">
              <label>{{ 'BOOKING.ADULTS' | translate }}</label>
              <div class="counter">
                <button (click)="decrementAdults()" [disabled]="adults() <= 1">−</button>
                <span>{{ adults() }}</span>
                <button (click)="incrementAdults()">+</button>
              </div>
            </div>
            <div class="search-field counter-field">
              <label>{{ 'BOOKING.CHILDREN' | translate }}</label>
              <div class="counter">
                <button (click)="decrementChildren()" [disabled]="children() <= 0">−</button>
                <span>{{ children() }}</span>
                <button (click)="incrementChildren()">+</button>
              </div>
            </div>
            <div class="search-cta">
              <div class="need-help">
                <span>{{ 'BOOKING.NEED_HELP' | translate }}</span>
                <span class="phone">+225 01840998765</span>
              </div>
              <button class="check-btn" (click)="loadAvailabilities()">{{ 'BOOKING.CHECK_AVAILABILITY' | translate }}</button>
            </div>
          </div>
        </div>
      </div>


      <main class="main-content">
        <div class="rooms-container">
          @if (isLoading()) {
            <div class="rooms-loading">
              <div class="spinner"></div>
              <p>{{ 'ROOMS.LOADING' | translate }}</p>
            </div>
          } @else if (!hasResults()) {
            <div class="rooms-empty">
              <p>{{ 'ROOMS.EMPTY' | translate }}</p>
            </div>
          } @else {

            @if (apartments().length > 0) {
              <div class="section-header">
                <span class="section-line"></span>
                <h2 class="section-title">{{ 'APARTMENTS.TITLE' | translate }}</h2>
                <span class="section-count">{{ apartments().length }}</span>
              </div>
              @for (apt of apartments(); track apt.id) {
                <div class="room-card apartment-card">
                  <div class="room-image">
                    <div class="img-placeholder apt-placeholder">
                      <svg xmlns="http://www.w3.org/2000/svg" width="52" height="52" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
                        <path d="M6 22V4a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v18"/>
                        <path d="M2 22h20"/>
                        <path d="M9 7h1"/><path d="M14 7h1"/>
                        <path d="M9 11h1"/><path d="M14 11h1"/>
                        <path d="M9 15h1"/><path d="M14 15h1"/>
                        <path d="M10 22v-4h4v4"/>
                      </svg>
                    </div>
                    @if (apt.coverImage) {
                      <img [src]="getImageSrc(apt.coverImage, sanitizer)" [alt]="apt.name" />
                    }
                  </div>
                  <div class="room-details">
                    <h3>{{ apt.name }}</h3>
                    @if (apt.appartmentType) {
                      <p class="room-desc">{{ apt.appartmentType.nom }}</p>
                    }
                    <div class="room-rating">
                      <div class="stars">
                        <span *ngFor="let star of getStars(apt.rating || 4)" class="star filled">★</span>
                        <span *ngFor="let star of getEmptyStars(apt.rating || 4)" class="star">★</span>
                      </div>
                      <span class="reviews">({{ apt.reviews }} {{ 'ROOMS.REVIEWS' | translate }})</span>
                    </div>
                    <p class="room-capacity">{{ apt.adults }} {{ 'ROOMS.ADULTS' | translate }}</p>
                    @if (apt.numberOfPieces) {
                      <p class="room-size">{{ apt.numberOfPieces }} {{ 'APARTMENTS.PIECES' | translate }}</p>
                    }
                    @if (apt.hotel) {
                      <p class="apt-hotel">{{ apt.hotel }}</p>
                    }
                  </div>
                  <div class="room-pricing">
                    <div class="price">
                      <span class="currency">FCFA</span>
                      <span class="amount">{{ (apt.price || 0) | number:'1.0-0' }}</span>
                      <span class="period">{{ 'ROOMS.PER_NIGHT' | translate }}</span>
                    </div>
                    <button class="select-btn" (click)="selectItem(apt)">{{ 'ROOMS.BOOK' | translate }}</button>
                  </div>
                </div>
              }
            }

            @if (rooms().length > 0) {
              <div class="section-header" [class.mt-section]="apartments().length > 0">
                <span class="section-line section-line-room"></span>
                <h2 class="section-title">{{ 'ROOMS.TITLE' | translate }}</h2>
                <span class="section-count section-count-room">{{ rooms().length }}</span>
              </div>
              @for (room of rooms(); track room.id) {
                <div class="room-card">
                  <div class="room-image">
                    <div class="img-placeholder room-placeholder">
                      <svg xmlns="http://www.w3.org/2000/svg" width="52" height="52" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
                        <path d="M2 4v16"/>
                        <path d="M2 8h18a2 2 0 0 1 2 2v10"/>
                        <path d="M2 17h20"/>
                        <path d="M6 8v9"/>
                        <circle cx="10" cy="12" r="1" fill="currentColor"/>
                      </svg>
                    </div>
                    @if (room.coverImage) {
                      <img [src]="getImageSrc(room.coverImage, sanitizer)" [alt]="room.name"  />
                    }
                  </div>
                  <div class="room-details">
                    <h3>{{ room.name }}</h3>
                    <p class="room-desc">{{ room.paymentType }}</p>
                    <div class="room-rating">
                      <div class="stars">
                        <span *ngFor="let star of getStars(room.rating || 4)" class="star filled">★</span>
                        <span *ngFor="let star of getEmptyStars(room.rating || 4)" class="star">★</span>
                      </div>
                      <span class="reviews">({{ room.reviews }} {{ 'ROOMS.REVIEWS' | translate }})</span>
                    </div>
                    <p class="room-capacity">{{ room.adults }} {{ 'ROOMS.ADULTS' | translate }} · {{ room.children }} {{ 'ROOMS.CHILD' | translate }}</p>
                    <p class="room-size">{{ room.size }} m²</p>
                  </div>
                  <div class="room-pricing">
                    <div class="price">
                      <span class="currency">FCFA</span>
                      <span class="amount">{{ (room.price || 0) | number:'1.0-0' }}</span>
                      <span class="period">{{ 'ROOMS.PER_NIGHT' | translate }}</span>
                    </div>
                    <button class="select-btn" (click)="selectItem(room)">{{ 'ROOMS.BOOK' | translate }}</button>
                  </div>
                </div>
              }
            }

          }
        </div>
      </main>

      <footer class="footer">
        <div class="footer-container">
          <div class="footer-grid">
            <div class="footer-col">
              <div class="footer-logo">
                <a routerLink="/" class="logo">
                  <img src="assets/images/logo%20kia%20ora.png" alt="Serenity Hotel" class="logo-img">
                </a>
              </div>
              <p class="footer-desc">
                {{ 'FOOTER.DESCRIPTION' | translate }}
              </p>
            </div>
            <div class="footer-col">
              <h4>{{ 'FOOTER.QUICK_LINKS' | translate }}</h4>
              <ul>
                <li><a routerLink="/booking">{{ 'FOOTER.BOOK_NOW' | translate }}</a></li>
                <li><a routerLink="/">{{ 'FOOTER.GALLERY' | translate }}</a></li>
                <li><a routerLink="/contact">{{ 'NAV.CONTACT' | translate }}</a></li>
                <li><a routerLink="/">{{ 'FOOTER.SERVICES' | translate }}</a></li>
              </ul>
            </div>
            <div class="footer-col">
              <h4>{{ 'FOOTER.COMPANY' | translate }}</h4>
              <ul>
                <li><a routerLink="/">{{ 'FOOTER.PRIVACY_POLICY' | translate }}</a></li>
                <li><a routerLink="/">{{ 'FOOTER.REFUND_POLICY' | translate }}</a></li>
                <li><a routerLink="/">{{ 'FOOTER.FAQ' | translate }}</a></li>
                <li><a routerLink="/about">{{ 'NAV.ABOUT' | translate }}</a></li>
              </ul>
            </div>
            <div class="footer-col">
              <h4>{{ 'FOOTER.SOCIAL_MEDIA' | translate }}</h4>
              <div class="social-links">
                <a href="#" aria-label="Facebook">
                  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"></path>
                  </svg>
                </a>
                <a href="#" aria-label="Instagram">
                  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <rect x="2" y="2" width="20" height="20" rx="5" ry="5"></rect>
                    <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"></path>
                    <line x1="17.5" y1="6.5" x2="17.51" y2="6.5"></line>
                  </svg>
                </a>
                <a href="#" aria-label="Twitter">
                  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M23 3a10.9 10.9 0 0 1-3.14 1.53 4.48 4.48 0 0 0-7.86 3v1A10.66 10.66 0 0 1 3 4s-4 9 5 13a11.64 11.64 0 0 1-7 2c9 5 20 0 20-11.5a4.5 4.5 0 0 0-.08-.83A7.72 7.72 0 0 0 23 3z"></path>
                  </svg>
                </a>
                <a href="#" aria-label="Pinterest">
                  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M12 0C5.373 0 0 5.373 0 12c0 5.084 3.163 9.426 7.627 11.174-.105-.949-.2-2.405.042-3.441.218-.937 1.407-5.965 1.407-5.965s-.359-.719-.359-1.782c0-1.668.967-2.914 2.171-2.914 1.023 0 1.518.769 1.518 1.69 0 1.029-.655 2.568-.994 3.995-.283 1.194.599 2.169 1.777 2.169 2.133 0 3.772-2.249 3.772-5.495 0-2.873-2.064-4.882-5.012-4.882-3.414 0-5.418 2.561-5.418 5.207 0 1.031.397 2.138.893 2.738.098.119.112.224.083.345l-.333 1.36c-.053.22-.174.267-.402.161-1.499-.698-2.436-2.889-2.436-4.649 0-3.785 2.75-7.262 7.929-7.262 4.163 0 7.398 2.967 7.398 6.931 0 4.136-2.607 7.464-6.227 7.464-1.216 0-2.359-.632-2.75-1.378l-.748 2.853c-.271 1.043-1.002 2.35-1.492 3.146C9.57 23.812 10.763 24 12 24c6.627 0 12-5.373 12-12S18.627 0 12 0z"></path>
                  </svg>
                </a>
              </div>
            </div>
          </div>
          <div class="footer-bottom">
            <p>{{ 'FOOTER.ALL_RIGHTS' | translate }}</p>
          </div>
        </div>
      </footer>
    </div>
